import {
  body,
  border2,
  heading,
  radius,
  rem,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { BreakpointSmall } from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('banner');

export const bannerStyles = css`
  :host {
    box-sizing: border-box;
    display: block;
    inline-size: 100%;
  }

  .banner {
    align-items: flex-start;
    background-color: ${token('accent-promotional-background')};
    border: ${border2(1, 'banner-border-default', 'solid')};
    border-radius: ${radius('medium')};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: ${spacing(150)};
    padding: ${spacing(250)};
    text-decoration: none;
    transition: background-color 0.2s ease-in-out;
  }

  @media (width <= ${unsafeCSS(BreakpointSmall)}) {
    .banner {
      flex-direction: column;
      gap: ${spacing(150)};
    }
  }

  .header-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    inline-size: 100%;
    justify-content: space-between;
  }

  @media (width > ${unsafeCSS(BreakpointSmall)}) {
    .header-container {
      display: contents;
    }

    .header-container .arrow-container {
      display: none;
    }
  }

  .banner:not(.has-subtitle) {
    align-items: center;
  }

  .logo-container {
    display: flex;
    flex-shrink: 0;
  }

  .content {
    color: ${token('banner-foreground-default')};
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: ${spacing(50)};
    max-inline-size: ${rem(700)};
    pointer-events: none;
  }

  .title {
    ${heading('small')};
    flex-grow: 1;
  }

  .sub-title {
    ${body('medium')};
  }

  .visual {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    pointer-events: none;
  }

  .arrow-container {
    align-self: center;
    display: flex;
    justify-content: center;
    margin-inline-start: auto;
    padding-inline: ${spacing(300)};
  }

  @media (width <= ${unsafeCSS(BreakpointSmall)}) {
    .banner > .arrow-container {
      display: none;
    }

    .banner .arrow-container {
      margin-inline-start: 0;
      padding-inline: 0;
    }
  }

  ::slotted(a-icon),
  .arrow-container a-icon {
    color: ${token('banner-icon-foreground-default')};
    font-size: ${spacing(250)};
  }
`;
